import '../css/app.scss';
import '../css/tailwind.css';
import '../../scripts/sections/footer.js';